import React, { useContext } from 'react'

import { DataTableContext } from './DataTable'
import { StyledContainerHeader } from './StyledDataTable'
import ColumnFilter from './ColumnFilter'
import ItemActions from 'components/SectionHandler/ItemActions'

const ContainerHeader = ({ FilterBtn }) => {
	const { label, withColumnFilter, width, tableActions } = useContext(DataTableContext)
	const rightHeaderItems = tableActions ? <ItemActions actions={tableActions}/> : null
	return(
		<StyledContainerHeader
			style={{ width: `${width}px` }}
			withColumnFilter={withColumnFilter}
			FilterBtn={!!FilterBtn}
		>
			{!!label && <p>{label}</p>}
			{withColumnFilter && <ColumnFilter/>}
			{rightHeaderItems}
			{FilterBtn}
		</StyledContainerHeader>

	)
}

export default ContainerHeader
